export const IMAGE_FILE_BASIC_PROPS = {
  mimeTypeArr: ["image/jpeg", "image/png"],
  heroImageMimeTypeArr: ["image/jpg", "image/jpeg", "image/png"],
  fileType: "JPG/PNG",
  maxSize: 5,
};

export const UPLOAD_BASIC_PROPS = {
  imageProps: {
    mimeTypeArr: ["image/jpeg", "image/png"],
    fileType: "JPG/PNG",
    maxSize: 5,
  },
  videoProps: {
    mimeTypeArr: [
      "video/mp4",
      "video/x-flv",
      "video/3gpp",
      "video/quicktime",
      "video/x-msvideo",
      "video/x-ms-wmv",
    ],
    fileType: "mp4/flv/avi/wmv/3gp/mov",
    maxSize: 500,
  },
};

export const TIME_FORMAT = "HH:mm A";
// export const UTC_DATE_TIME_FORMAT = "DD-MM-YYYY HH:mm";
export const UTC_DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm";

export const COMETCHAT_CONSTANTS = {
  APP_ID: "21067461f3aeda19",
  REGION: "eu",
  AUTH_KEY: "d7b99dff176a6711c2b62d9ed5b89d06e8dd3c5c",
  // UID: "SUPERHERO1",
};

export const LOGO_DEMO = {
  URL: "https://gravit8-dev-static.s3.amazonaws.com/development/event_logo_demo_size.png",
  FILENAME: "event_logo_demo_size.png",
};

export const STATIC_URLS = {
  default_chatbot:
    "https://gravit8-dev-static.s3.amazonaws.com/development/default+chat+bot.xlsx",
};

export const DEFAULT_CHATBOT_HISTORY = [
  {
    key: "left_message_0",
    message: "Hi! How can we help you?",
    position: "left",
  },
];

export const INPUT_TEXT_LIMITS = {
  MAX: 50,
};

export const TEXTAREA_TEXT_LIMITS = {
  MAX: 500,
};

export const PAGINATION_DEFAULT_SETTINGS = {
  page_no: 1,
  no_of_records: 10,
  no_of_records_brands: 8,
};
